/**
 * Check if the current browser is officially supported by twilio-video-procesors.js.
 * https://github.com/twilio/twilio-video-processors.js/blob/master/lib/utils/support.ts
 */
function isSupported() {
  return !!window.OffscreenCanvas && !/Mobi/i.test(window.navigator.userAgent) && !!window.chrome;
}

export default isSupported;
